import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthWebService } from "app/services/authweb.service";
import { CountryService } from "app/services/country.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { ToastrService } from "ngx-toastr";
import { CarrierDepotService } from "../service/carrier-depot.service";
@Component({
  selector: "app-display-carrier-depot",
  templateUrl: "./display-carrier-depot.component.html",
  styleUrls: ["./display-carrier-depot.component.scss"],
})
export class DisplayCarrierDepotComponent implements OnInit {
  @Input() data: string;
  isLoading: boolean = false;
  carrierId;
  ddlCountries = [];
  carrierDepotList: any = [];
  currentPage = 1;
  page = 1;
  pageSize: number = 10;
  count: number = 0;
  user: any = {};
  isEmpty: boolean = false;
  @ViewChild("content") modal: NgbModal;
  depot:any;
  @ViewChild('detailViewDetails') detailModal: NgbModal;

  deleteConfirm = "";
  closeResult: string = "";
  removeRef: any;
  currentRoute;
  constructor(
    private authWebService: AuthWebService,
    private _service: CarrierDepotService,
    public utility: UtilityServiceService,
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private toastService: ToastrService,
    private confirmDialogService: ConfirmDialogService
  ) {
    this.user = this.authWebService.userData
      ? this.authWebService.userData.User
      : null;
    this._activatedRoute.params.subscribe((params: Params) => {
      this.carrierId = params["id"];
    });
  }

  ngOnInit(): void {
   // this.carrierId = this.data;
    this.getDepotList();
    this.utility.page = 1;
  }

  getDepotList = (page: number = 1, pageSize: number = 10) => {
    this.isLoading = true;
    this._service.getDepotList(this.carrierId).subscribe(
      (response: any) => {
        if (response && response.length > 0) {
          this.carrierDepotList = response;
          this.count = response.length;
          this.isLoading = false;
        } else {
          this.isEmpty = true;
          this.isLoading = false;
        }
      },
      (error) => {
        this.isEmpty = true;
        this.isLoading = false;
      }
    );
  };

  onAddDepot() {
    this._router.navigate([`/carrier-depot/add/${this.carrierId}`]);
  }

  onEditDepot(depot: any) {
    this._router.navigate([
      `/carrier-depot/edit/${this.carrierId}/${depot.id}`,
    ]);
  }

  onViewDetails(depot: any) {
    console.log(this.carrierId), "DEPOT @@@@@@@@@@@@@@@@@@";

    if(depot) this.depot = depot;
    this.modalService.open(this.detailModal, { ariaLabelledBy: 'modal-basic-title',size: 'xl', scrollable: true  }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  onNextOrPrevious(page: number = 1) {
    this.getDepotList(page, this.pageSize);
    this.currentPage = page;
    return page;
  }

  onDeleteDepot(depot) {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to delete this depot information?",
      () => {
        this.isLoading = true;

        this._service.delete(depot.id).subscribe(
          (data) => {
            this.toastService.success(
              "The depot information was deleted successfully",
              "success"
            );
            this.getDepotList();

            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            this.toastService.error(
              "Your request could not be processed succesfully.Please contact the system admin if the problem persists.",
              "error"
            );
          }
        );
      },
      () => {
        return false;
      }
    );
  }

  onDelete(id) {
    this._service.deleteDepot(id).subscribe(
      (result) => {
        this.toastService.success(
          `Vehicle Type ${this.removeRef.code} deleted.`,
          "Delete Vehicle Type"
        );
        if (result != null) {
          this.onNo();
          this.getDepotList();
        }
      },
      (error) => {
        error = error.json();
        this.toastService.error(
          `Vehicle Type ${this.removeRef.code} was not deleted.`,
          "Delete Vehicle Type"
        );
      }
    );
  }

  onNo() {
    console.log("no");
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
